import { useContext, useEffect, useState } from 'react';
import { Timer } from '@fff-web/fff-utilities';
import { useBootstrapLD } from './useBootstrapLD';
import GlobalNavInternalContext from '../context/GlobalNavInternalContext';
import {
  ACTIVE_CHECKOUT,
  PASSIVE_CHECKOUT,
  TIMER_COMPLETED,
  USER_COMPLETED,
  READY_FOR_SALE,
  USER_ONBOARDING_1,
  USER_ONBOARDING_2,
  USER_ONBOARDING_3,
  USER_ONBOARDING_4,
} from '../helpers/constants/newMemberStates';
import { getTimer } from '../services';
import { newMemberStateUrlMap } from '../helpers/newMemberStateUrlMap';

const withFinalSlash = (url) => (url.endsWith('/') ? url : `${url}/`);

export function useNmfTimer() {
  const {
    env,
    onNewMemberStateFetched,
  } = useContext(GlobalNavInternalContext);
  const {
    newMemberOnboardingFF: newMemberOnboardingFlag,
    newMemberOnboardingReady: newMemberOnboardingFlagReady,
  } = useBootstrapLD(env);
  const [timer, setTimer] = useState({
    endTime: null,
    userId: null,
    newMemberState: null,
    lastVisitedCustomizeQuestionId: null,
    timerType: 'NEW_MEMBER',
    timerSource: '',
    flashSaleId: null,
    loading: true,
  });

  let NMFPages = [];

  if (!newMemberOnboardingFlag) {
    NMFPages = [
      '/new-member-customize/',
      '/new-member-customize/confirmation/',
    ];
  } else {
    NMFPages = newMemberStateUrlMap.map((mapItem) => mapItem.nmUrls).flat();
  }

  const updateTimer = (res) => {
    setTimer({
      endTime: res.endTime,
      userId: res.userId,
      newMemberState: res.newMemberState,
      lastVisitedCustomizeQuestionId: res.lastVisitedCustomizeQuestionId,
      timerType: res.timerType,
      timerSource: res.timerSource,
      flashSaleId: res.flashSaleId,
      loading: false,
    });
    onNewMemberStateFetched(res.newMemberState);
  };

  useEffect(() => {
    if (!newMemberOnboardingFlagReady) {
      return;
    }
    (async () => {
      try {
        const res = await getTimer(env);
        // allow new member to navigate back to NMC if has completed NMF and Flash Sale is open
        if (
          [
            READY_FOR_SALE,
            USER_ONBOARDING_1,
            USER_ONBOARDING_2,
            USER_ONBOARDING_3,
            USER_ONBOARDING_4,
            USER_COMPLETED,
          ].includes(res?.newMemberState) &&
          res?.flashSaleId &&
          NMFPages.some(
            (url) =>
              withFinalSlash(url) === withFinalSlash(window.location.pathname),
          )
        ) {
          updateTimer(res);
        }
        // if there is no timer or time is up redirect new member to homepage
        else if (
          !res ||
          (res.endTime &&
            Timer.getTimeLeft(new Date(`${res.endTime}Z`)).timeUp) ||
          [
            READY_FOR_SALE,
            USER_ONBOARDING_1,
            USER_ONBOARDING_2,
            USER_ONBOARDING_3,
            USER_ONBOARDING_4,
            USER_COMPLETED,
            ACTIVE_CHECKOUT,
            PASSIVE_CHECKOUT,
            TIMER_COMPLETED,
          ].includes(res.newMemberState)
        ) {
          if (window.location.href !== env.REACT_APP_BASE_URL) {
            window.location.href = env.REACT_APP_BASE_URL;
          }
        }
        updateTimer(res);
      } catch (err) {
        console.error(err);
        setTimer(false);
      }
    })();
  }, [newMemberOnboardingFlagReady]);
  return timer;
}
